module.exports = __webpack_public_path__ + "img/connection-sidebar-act.7926ed0d.svg";